<template>
    <div class="live-host-count info-box">
        <h3>签到数据</h3>

        <el-tabs
            v-if="signList.length"
            class="sign-tab" v-model="signTab" type="card" >
            <el-tab-pane
                v-for="item in signList"
                :label="item.create_time"
                :name="item.sign_id"
                :key="item.sign_id">
                <div class="sign-wrap sc-table">
                    <p class="sign-num">签到人数：{{item.signMembers && item.signMembers.length}}</p>
                    <el-table
                        class="sign-table"
                        :data="item.signMembers"
                        :border="true"
                        :stripe="false"
                        :max-height="300"
                    >
                        <!-- column title -->
                        <el-table-column type="index" width="60" align="center"></el-table-column>
                        <el-table-column prop="name" label="姓名" align="center" width="140px"></el-table-column>
                        <el-table-column prop="create_time" label="签到时间" align="center"></el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
        </el-tabs>

        <div v-else class="no-data">
            <p>暂无签到数据</p>
        </div>

    </div>
</template>

<script>
export default {
    props: ['id'],
    data() {
        return {
            signList: [],
            signTab: '',
        }
    },
    watch: {
        signTab(signId) {
            if (!Number(signId)) return

            this.$api.getLiveRoomSignDetail(this.id, signId).then(res => {
                let signMembers = res.package?.lists
                let idx = this.signList.findIndex(item => item.sign_id === signId)

                this.signList[idx]['signMembers'] = signMembers
                this.signList = [...this.signList]
            })
        }
    },
    mounted() {
        this.getSignList()
    },
    methods: {
        async getSignList() {
            let res = await this.$api.getLiveRoomSign(this.id)
            this.signList = res.package?.lists || []

            if (this.signList.length) {
                this.$nextTick(() => {
                    this.signTab = this.signList[0]['sign_id']
                })
            }
        },

    },
}
</script>

<style lang="scss">
.live-host-count {

    .sign-table {
        width: 500px;
    }

    .sign-tab {
        padding-left: 20px;
        width: 1000px;

        .el-tabs__header {
            margin-bottom: 10px;
        }

        .el-tabs__content {
            min-height: 100px;
            max-height: 400px;
            overflow: auto;
        }

        .sign-wrap {
            .sign-num {
                margin-bottom: 10px;
            }
        }
    }

    .no-data {
        padding-left: 20px;
        color: #999;
    }

}
</style>
